import React, { Component } from "react";
import "./Query.css";
import Ripples from "react-ripples";
import firebase from "firebase/app";
// import Ripples from 'react-ripples';
import firestore from "firebase/firestore";
import { firebaseConfig } from "./FirebaseConfig";
import { BrowserRouter as Router, Link } from "react-router-dom";
import AppBar from "./AppBar";
import QueryTab from "./TabsComponent/QueryTab";

import Modal from "react-awesome-modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure();

export class Query extends Component {
  constructor(props) {
      super(props)
      this.state = {
        admin_email:'admin@gmail.com'
         
      }
  };

  

  render() {
    // console.log("Values = ", this.state.violations);

    return (
      <div className={"queryMainDiv"}>
        <div className={"queryHeaderAppBarDiv"}>
          <AppBar message="QUERY" email={this.state.admin_email}/>
        </div>

        <div className={"queryFooterDiv"}>
          <div className={"queryFooterListDiv"}>
            <div
              style={{
                height: "90vh",
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <QueryTab />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Query;
